import { Grid } from "@mui/material";
import { useResponsive } from "../../../../../src/Modulo_Responsive/Hooks/useResponsive";
import posts from "../../../../Data/post.json";
import Tarjeta_Blog_Blog2 from "../../Tarjetas/Tarjeta_Blog_Blog2";

const Lista_Blogs = ({ ids }) => {
    const { sCell } = useResponsive();

    return (
        <Grid container
              justifyContent="flex-start"
              alignItems="stretch"
              size={{ xs: 12, sm: 12, md: 12 }}
              spacing={sCell?8:4}>
            {posts.filter(post => ids.includes(post.id)).map((post, index) => (
                <Grid
                    container
                    key={index}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={{ xs: 12, sm: 6, md: 6, lg: 4 }}
                >
                    <Tarjeta_Blog_Blog2
                        imagen={post.imagen}
                        titulo={post.titulo}
                        descripcion={post.descripcion}
                        link={post.slug}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default Lista_Blogs;